import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';

import { SimpleDropdown } from 'ui-components/components/dropdown';

import { FilterItem } from './filter-item';
import messages from './messages';
import drawerMessages from '../../../messages';
import { getLookbackPeriods } from '../../../utils/time-periods';

const lookbackPeriodOptions = getLookbackPeriods().map((period) => ({
  value: period.key,
  label: <FormattedMessage {...period.messageDescriptor} />,
}));

/**
 * LookbackPeriodFilter component that provides a dropdown for selecting lookback period
 * @param {object} props - Component props
 * @param {string} props.value - Current selected value
 * @param {(value: string) => void} props.onChange - Callback function when value changes
 * @returns {React.ReactElement} The rendered LookbackPeriodFilter component
 */
export const LookbackPeriodFilter = ({ value, onChange }) => {
  const { formatMessage } = useIntl();

  return (
    <FilterItem
      ariaLabel={formatMessage(messages.lookbackPeriodFilterAriaLabel)}
      inputComponent={
        <SimpleDropdown
          onItemSelected={onChange}
          options={lookbackPeriodOptions}
          placeholder={<FormattedMessage {...messages.lookbackPeriodPlaceholder} />}
          selectedItemValue={value}
        />
      }
      label={drawerMessages.lookbackPeriodLabel}
    />
  );
};
